// extracted by mini-css-extract-plugin
export default {"editProfileBody":"EditUserProfileBody_editProfileBody__MyTPu","themeSection":"EditUserProfileBody_themeSection__YPsVj"};